import React, { FC } from 'react';
import { serverSideTranslation } from '../../../util/next';

import { initSmartSiteData } from '../../../api/smartApi';
import { getPageContent } from '../../../api/pagesApi';

import { SmartPageContainer } from '../../../components/SmartPageContainer';
import NewsFooter from '../../../modules/NewsFooter';

const UserRight: FC = (props: any) => {
  const { _nextI18Next: i18n, pageContentData } = props;
  const { shareContent = {} } = pageContentData || {};
  const description = shareContent.shareDetail || '用户权益';
  const title = shareContent.shareTitle || '用户权益';
  const pageUrl = '/csr/people/user-rights/meituan';

  return (
    <>
      <SmartPageContainer title={title} description={description} pageUrl={pageUrl} {...props} />
      <div className="bg-white">
        <NewsFooter category="csr" lanType={i18n.initialLocale} positionNo="csr_3" />
      </div>
    </>
  );
};
export async function getServerSideProps({ locale, query }: any) {
  const pageContentParams = {
    uri: '/csr/people/user-rights',
    pageContentNo: query.pageContentNo,
    preview: query.preview,
  };
  const pageContentData = await getPageContent(pageContentParams, locale);
  return {
    props: {
      lxCustom: {
        cid: 'c_donation_69ru3qa8',
        locale,
        ...pageContentData?.shareContent,
      },
      pageContentData,
      ...(await initSmartSiteData(locale)),
      ...(await serverSideTranslation(locale, ['home', 'cookie', 'common'])),
    },
  };
}
export default UserRight;
